import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { JobBoardService } from '../service/job-board.service';

@Component({
  selector: 'app-job-board-sort-by',
  templateUrl: './job-board-sort-by.component.html',
  styleUrls: ['./job-board-sort-by.component.scss'],
})
export class JobBoardSortByComponent implements OnInit {
  @ViewChild('sortBy') sortBy: any;
  @ViewChild('sortDirection') sortDirection: any;
  @Output() sort: EventEmitter<any> = new EventEmitter<any>();

  constructor(private jobBoardService: JobBoardService) {}

  async ngOnInit(): Promise<void> {
    let localFilterState = await this.jobBoardService.getLocalBoardFilterState();
    if (this.sortBy?.nativeElement)
      this.sortBy.nativeElement.value = localFilterState?.order.split(',')[0] || 'ownerName';
    if (this.sortDirection?.nativeElement)
      this.sortDirection.nativeElement.value = localFilterState?.order.split(',')[1] || 'ASC';
  }

  sortBoardData(sortByProperty: String, sortDirection: String) {
    let sortData = {
      sortBy: sortByProperty,
      sortDirection,
    };
    this.sort.emit(sortData);
  }
}
